module.exports = __webpack_public_path__ + "static/media/fork-knife.14a09577.svg";